export const AUTOMATION_TRIGGER_TYPES = [
    'long_break',
    'long_shift_reminder',
    'auto_end_shift',
];

export const getDefaultRuleData = (triggerType, name) => {
    const base = {
        name,
        trigger_type: triggerType,
        is_active: true,
    };

    if (triggerType === 'long_break') {
        return {
            ...base,
            conditions: { duration_minutes: { gt: 30 } },
            actions: {
                notification: {
                    message: "Don't forget to end your break, {{employee_name}}!",
                },
            },
        };
    }

    if (triggerType === 'long_shift_reminder') {
        return {
            ...base,
            conditions: { hours: { gt: 8 } },
            actions: {
                notification: {
                    title: 'Pripomienka na ukončenie zmeny',
                    message: 'Máš už viac ako {{hours}} hodín. Nezabudol si sa vypnúť?',
                },
            },
        };
    }

    return {
        ...base,
        conditions: { hours: { gt: 24 } },
        actions: {
            notification: {
                title: 'Zmena automaticky ukončená',
                message: 'Tvoja zmena bola automaticky ukončená po {{hours}} hodinách. Prosím, skontroluj si to v aplikácii.',
            },
        },
    };
};

export const parseRuleToFormState = (rule) => {
    const conditions = rule?.conditions || {};
    const actions = rule?.actions || {};
    const triggerType = rule?.trigger_type || 'long_break';

    let duration = 30;
    if (triggerType === 'long_break') {
        duration = conditions.duration_minutes?.gt || 30;
    } else {
        duration = conditions.hours?.gt || 8;
    }

    return {
        duration,
        notificationTitle: actions.notification?.title || '',
        notificationMessage: actions.notification?.message || '',
    };
};

export const buildRulePayload = (rule, formState) => {
    const triggerType = rule.trigger_type;
    const payload = {
        name: rule.name,
        trigger_type: triggerType,
        is_active: rule.is_active,
    };

    if (triggerType === 'long_break') {
        payload.conditions = {
            duration_minutes: { gt: parseInt(formState.duration, 10) },
        };
        payload.actions = {
            notification: { message: formState.notificationMessage },
        };
    } else {
        payload.conditions = {
            hours: { gt: parseInt(formState.duration, 10) },
        };
        payload.actions = {
            notification: {
                title: formState.notificationTitle,
                message: formState.notificationMessage,
            },
        };
    }

    return payload;
};

export const mapRulesByTriggerType = (rules) => {
    const map = {};
    (rules || []).forEach((rule) => {
        if (!map[rule.trigger_type]) {
            map[rule.trigger_type] = rule;
        }
    });
    return map;
};
